import dayjs from 'dayjs'

import 'dayjs/locale/en'
import 'dayjs/locale/da'

export function setDayjsLocale(locale: string) {
  try {
    dayjs.locale(locale)
  } catch {
    console.warn(`[dayjs] Locale "${locale}" not found — falling back to 'en'`)
    dayjs.locale('en')
  }
}
